import React, { useContext, useEffect } from "react";
import "./ProfileMenu.css";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import PROFILE from "../../assets/profilePic.svg";
import { LuInfo, LuHistory, LuSettings, LuBookOpen } from "react-icons/lu";
import { FiLogOut } from "react-icons/fi";
import toast from "react-hot-toast";
import { AppContext } from "../../utils/Context/AppContext";

const ProfileMenu = ({ setShowProfileMenu }) => {
  const navigate = useNavigate();
  const { accounts, instance } = useMsal();
  const { isAdmin } = useContext(AppContext);

  const account = accounts[0];
  const displayName =
    account?.name || localStorage.getItem("userName") || "User";
  const userEmail =
    account?.username || localStorage.getItem("userId") || "example@email.com";

  const handleLogout = async () => {
    setShowProfileMenu(false);

    const accounts = instance.getAllAccounts();

    try {
      if (accounts.length > 0) {
        await instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: `${window.location.origin}/logout-success`,
        });
      } else {
        clearAppStorage();
        toast.success("You’ve been logged out.");
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.error("Logout failed:", error);
      clearAppStorage();
      toast.success("You’ve been logged out.");
      navigate("/", { replace: true });
    }
  };

  // Utility function to clean up app-specific storage
  const clearAppStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  return (
    <div className="profile-menu">
      <div className="flex gap-4 border-b px-4 py-2  border-t-[#CDCDCD1A]">
        <img src={PROFILE} />
        <div className="flex-1 ">
          <div className="flex items-center gap-2">
            <p className="text-[#242424] font-bold text-[14px]">{displayName}</p>
            {isAdmin && (
              <span className="text-[10px] font-semibold text-[#00AEEF] bg-[#EFFBFF] px-2 py-[1px] rounded-full">
                Admin
              </span>
            )}
          </div>
          <p className="text-[#616161] font-normal text-[12px]">{userEmail}</p>
        </div>
      </div>
      <div className="flex flex-col gap-2 px-2 py-2 items-start text-[#242424] font-normal ">
        {isAdmin && (
          <button
            onClick={() => {
              setShowProfileMenu(false);
              navigate("/activity-log");
            }}
            className="flex-1 py-2 flex gap-2 items-center px-4 w-full hover:underline hover:bg-[#EFFBFF] font-bold hover:border hover:border-[#00AEEF] rounded-[4px]"
          >
            <span>
              <LuHistory color="#242424" size={16} />
            </span>
            Activity Log
          </button>
        )}
        {isAdmin && (
          <button
            onClick={() => {
              setShowProfileMenu(false);
              navigate("/settings");
            }}
            className="flex-1 py-2 flex gap-2 items-center px-4 w-full hover:underline hover:bg-[#EFFBFF] font-bold hover:border hover:border-[#00AEEF] rounded-[4px]"
          >
            <span>
              <LuSettings color="#242424" size={16} />
            </span>
            Settings
          </button>
        )}
        {isAdmin && (
          <button
            onClick={() => {
              setShowProfileMenu(false);
              navigate("/member-knowledge-base");
            }}
            className="flex-1 py-2 flex gap-2 items-center px-4 w-full hover:underline hover:bg-[#EFFBFF] font-bold hover:border hover:border-[#00AEEF] rounded-[4px]"
          >
            <span>
              <LuBookOpen color="#242424" size={16} />
            </span>
            Member Knowledge Base
          </button>
        )}
        <button
          onClick={() =>
            window.open(
              "https://www.neca.asn.au/branch/niki-user-guide",
              "_blank"
            )
          }
          className="flex-1 py-2 flex gap-2 items-center px-4 w-full hover:underline hover:bg-[#EFFBFF] font-bold hover:border hover:border-[#00AEEF] rounded-[4px]"
        >
          <span>
            <LuInfo color="#242424" size={16} />
          </span>
          User Guide
        </button>
        <button
          onClick={handleLogout}
          className="flex-1 py-2 flex gap-2 items-center px-4 w-full hover:underline hover:bg-[#EFFBFF] font-bold hover:border hover:border-[#00AEEF] rounded-[4px]"
        >
          {" "}
          <span>
            <FiLogOut color="#242424" size={16} />
          </span>{" "}
          Logout
        </button>
      </div>
    </div>
  );
};

export default ProfileMenu;
